import React, { useState } from 'react';
import { RiStarLine, RiTrophyLine } from 'react-icons/ri';

export default function Tabs({ tabs, defaultTab = 0, className = "", activeTabClassName = "" }) {
  const [activeTab, setActiveTab] = useState(defaultTab);

  // Map icon types to actual icon components
  const getIcon = (type) => {
    switch (type) {
      case 'star':
        return RiStarLine;
      case 'trophy':
        return RiTrophyLine;
      default:
        return null;
    }
  };

  return (
    <div className={`w-full mt-6 mb-8`}>
      {/* Tab Navigation */}
      <div className="flex items-center gap-3 mb-4">
        {tabs.map((tab, index) => {
          const Icon = getIcon(tab.iconType);
          const isActive = activeTab === index;
          return (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              aria-selected={isActive}
              role="tab"
              className={`
                relative px-5 py-2.5 text-14 font-text rounded-xl transition-all font-medium
                border
                ${isActive
                  ? `${activeTabClassName || 'bg-gradient-title'} text-white border-transparent shadow-md`
                  : 'text-secondary/70 border-secondary/15 hover:border-secondary/30 hover:bg-white/50'}
                min-w-[130px]
                flex items-center justify-center gap-2
                focus:outline-none focus:ring-2 focus:ring-primary/30
              `}
            >
              {Icon && <Icon className="size-4" />}
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div role="tabpanel">
        {tabs[activeTab].content}
      </div>
    </div>
  );
}
